"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromotionCancellationPolicies = exports.getPromotionCancellationPolicyByCode = void 0;
var promotionCancellationPolicies = [
    { code: 'non-refundable', description: 'Non refundable', numberOfDays: 0 },
    { code: 'prior-to-check-in-one-day', description: 'Cancellations permitted 1 day prior to arrival', numberOfDays: 1 },
    { code: 'prior-to-check-in-three-days', description: 'Cancellations permitted 3 day prior to arrival', numberOfDays: 3 },
    { code: 'prior-to-check-in-seven-days', description: 'Cancellations permitted 7 day prior to arrival', numberOfDays: 7 },
    { code: 'prior-to-check-in-fourteen-days', description: 'Cancellations permitted 14 day prior to arrival', numberOfDays: 14 },
];
var getPromotionCancellationPolicyByCode = function (policyCode) { return promotionCancellationPolicies.find(function (policy) { return policy.code === policyCode; }); };
exports.getPromotionCancellationPolicyByCode = getPromotionCancellationPolicyByCode;
var getPromotionCancellationPolicies = function () { return promotionCancellationPolicies; };
exports.getPromotionCancellationPolicies = getPromotionCancellationPolicies;
